import React from 'react'
import { getLiveApi } from './api'
import { Entries, LookupValues } from '../common/types/api/LiveLookupResponse'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getLookupValues(lookup: string): Promise<Entries[]> {
    try {
        const lookupValues = await getLiveApi<LookupValues>(`lookup/${lookup}`)

        return lookupValues.entries
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get lookup values: ')}>{error}</Notification>,
            20
        )

        console.error(error)

        return []
    }
}

export function mockGetLookupValues(data: { [lookups: string]: Entries[] }): (lookup: string) => Promise<Entries[]> {
    return function (lookup) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(data[lookup])
            }, 1000)
        })
    }
}
